import {clientAxios8080} from "../../app/configs/axios";

export const getFallas=  () => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-catalogos/filtros/ticket/tipo/falla')
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getStatusTicket=  () => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-catalogos/filtros/tickets/statusticket')
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getTipoTicket=  () => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-catalogos/filtros/tickets/tipoticket')
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getTipoReq =  () => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-catalogos/filtros/tipo/requerimiento')
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getTotalesRT =  () => {
  return new Promise((resolve, reject) => {
    clientAxios8080.post('/ms-tickets/tickets/reportes/generales/ticket')
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getTicketsDet = (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080
      .post('/ms-tickets/tickets/reportes/detalle/ticket', {
        ...filters,
        paginador: {
          limit: 2000,
          pagina: 0,
        },
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};